import hljs from "highlight.js/lib/core";
import bash from "highlight.js/lib/languages/bash";
import json from "highlight.js/lib/languages/json";
import python from "highlight.js/lib/languages/python";
import sql from "highlight.js/lib/languages/sql";
import xml from "highlight.js/lib/languages/xml";
import yaml from "highlight.js/lib/languages/yaml";
import * as React from "react";

import "./HighlightedCodeBody.css";
import { HighlightedCsvBody } from "./HighlightedCsvBody";
import roboql from "./roboqlLanguage";

hljs.registerLanguage("python", python);
hljs.registerLanguage("sql", sql);
hljs.registerLanguage("bash", bash);
hljs.registerLanguage("json", json);
hljs.registerLanguage("yaml", yaml);
hljs.registerLanguage("xml", xml);
hljs.registerLanguage("roboql", roboql);
hljs.registerAliases(["sh", "shell", "zsh"], { languageName: "bash" });
hljs.registerAliases(["yml"], { languageName: "yaml" });

interface HighlightedCodeBodyProps {
  code: string;
  language: string;
}

const HighlightedCodeBody: React.FC<HighlightedCodeBodyProps> = ({
  code,
  language,
}) => {
  // CSV has no useful highlight.js grammar (column-rotating colors are
  // stateful, hljs grammars are not). Dispatch to a dedicated renderer.
  if (language === "csv") {
    return <HighlightedCsvBody code={code} />;
  }

  return <HljsBody code={code} language={language} />;
};

const HljsBody: React.FC<HighlightedCodeBodyProps> = ({ code, language }) => {
  const html = React.useMemo(() => {
    try {
      return hljs.highlight(code, { language, ignoreIllegals: true }).value;
    } catch {
      return "";
    }
  }, [code, language]);

  if (!html) {
    return <code>{code}</code>;
  }
  return (
    <code
      className={`hljs language-${language}`}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
};

export default HighlightedCodeBody;
